export const buildBreadcrumbSchema = (crumbs) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": crumbs.map(({ name, url }, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": name,
    "item": url
  }))
});
